import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { toast } from 'sonner';
import { Share2, Copy, Check } from 'lucide-react';

// 社交平台图标组件
const WeiboIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M10.098 20.323c-3.977.391-7.414-1.406-7.672-4.02-.259-2.609 2.759-5.047 6.74-5.441 3.979-.394 7.413 1.404 7.671 4.018.259 2.6-2.759 5.049-6.739 5.443zM9.05 17.219c-.384.616-1.208.884-1.829.602-.612-.279-.793-.991-.406-1.593.379-.595 1.176-.861 1.793-.601.622.263.82.972.442 1.592zm1.27-1.627c-.141.237-.449.353-.689.253-.236-.09-.313-.361-.177-.586.138-.227.436-.346.672-.24.239.09.315.36.194.573zm.176-2.719c-1.893-.493-4.033.45-4.857 2.118-.836 1.704-.026 3.591 1.886 4.21 1.983.64 4.318-.341 5.132-2.179.8-1.793-.201-3.642-2.161-4.149zm7.563-1.224c-.346-.105-.578-.18-.402-.649.384-.987.424-1.837.008-2.449-.78-1.148-2.914-1.086-5.344-.03 0 0-.766.331-.571-.269.376-1.198.32-2.203-.266-2.782-1.33-1.311-4.869.047-7.91 3.032C1.607 10.396 0 12.702 0 14.725c0 3.865 4.958 6.218 9.806 6.218 6.351 0 10.579-3.69 10.579-6.623 0-1.77-1.492-2.779-2.526-3.1zm2.961-4.799c-.398-.479-.993-.748-1.676-.756-.203 0-.35.021-.461.042-.112.014-.161-.049-.14-.161.056-.266.168-.504.308-.7.154-.21.385-.392.623-.52.266-.14.559-.21.854-.21.476 0 .91.168 1.225.476.322.307.504.728.504 1.186 0 .252-.042.504-.126.756-.091.259-.364.154-.294-.028.049-.133.077-.273.077-.42 0-.224-.07-.434-.203-.602z"/>
  </svg>
);

const WeChatIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.045c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 01-.023-.156.49.49 0 01.201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-7.062-6.122zm-2.036 2.891c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982z"/>
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

/**
 * 社交分享按钮组件
 * @param {Object} props
 * @param {string} props.url - 要分享的URL
 * @param {string} props.title - 分享标题
 * @param {string} props.description - 分享描述
 * @param {string} props.image - 分享图片URL (可选)
 * @param {string} props.variant - 按钮样式 "ghost" | "outline" | "default"
 * @param {string} props.size - 按钮大小 "sm" | "default" | "lg" | "icon"
 * @param {string} props.className - 额外的CSS类名
 */
const ShareButton = ({ 
  url, 
  title = '', 
  description = '', 
  image = '',
  variant = 'ghost',
  size = 'sm',
  className = ''
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  // 获取完整URL
  const getFullUrl = () => {
    if (url.startsWith('http')) return url;
    return `${window.location.origin}${url}`;
  };

  // 获取完整图片URL
  const getFullImageUrl = () => {
    if (!image) return '';
    if (image.startsWith('http')) return image;
    // 相对路径转换为完整URL
    return `${window.location.origin}${image}`;
  };

  const fullUrl = getFullUrl();
  const fullImageUrl = getFullImageUrl();
  const encodedUrl = encodeURIComponent(fullUrl);
  const encodedTitle = encodeURIComponent(title);
  const encodedDesc = encodeURIComponent(description);

  // 分享到微博 - 先复制图片URL，然后打开微博分享
  const shareToWeibo = async () => {
    // 如果有图片，先复制到剪贴板并提示用户
    if (fullImageUrl) {
      try {
        await navigator.clipboard.writeText(fullImageUrl);
        toast.success(t('share.weiboImageCopied', '图片链接已复制，请在微博编辑页粘贴添加图片'));
      } catch (err) {
        console.error('Failed to copy image URL:', err);
      }
    }
    // 打开微博分享页面
    const weiboUrl = `https://service.weibo.com/share/share.php?url=${encodedUrl}&title=${encodedTitle}`;
    window.open(weiboUrl, '_blank', 'width=600,height=500');
  };

  // 分享到微信 (复制链接)
  const shareToWeChat = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success(t('share.wechatCopied', '链接已复制，请打开微信粘贴分享'));
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error(t('share.copyFailed', '复制失败，请手动复制'));
    }
  };

  // 分享到 X (Twitter)
  const shareToX = () => {
    const xUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
    window.open(xUrl, '_blank', 'width=600,height=400');
  };

  // 分享到 Facebook
  const shareToFacebook = () => {
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedTitle}`;
    window.open(fbUrl, '_blank', 'width=600,height=400');
  };

  // 分享到 Telegram
  const shareToTelegram = () => {
    const tgUrl = `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`;
    window.open(tgUrl, '_blank', 'width=600,height=400');
  };

  // 分享到 WhatsApp
  const shareToWhatsApp = () => {
    const waUrl = `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`;
    window.open(waUrl, '_blank', 'width=600,height=400');
  };

  // 复制链接
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast.success(t('share.linkCopied', '链接已复制'));
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error(t('share.copyFailed', '复制失败'));
    }
  };

  // 原生分享 (移动端)
  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: description,
          url: fullUrl,
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Share failed:', err);
        }
      }
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className={className} data-testid="share-button">
          <Share2 className="w-4 h-4" />
          {size !== 'icon' && <span className="ml-1">{t('share.share', '分享')}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {/* 中国平台 */}
        <DropdownMenuItem onClick={shareToWeibo} className="cursor-pointer">
          <WeiboIcon />
          <span className="ml-2">{t('share.weibo', '微博')}</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={shareToWeChat} className="cursor-pointer">
          <WeChatIcon />
          <span className="ml-2">{t('share.wechat', '微信')}</span>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        {/* 国际平台 */}
        <DropdownMenuItem onClick={shareToX} className="cursor-pointer">
          <XIcon />
          <span className="ml-2">X (Twitter)</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={shareToFacebook} className="cursor-pointer">
          <FacebookIcon />
          <span className="ml-2">Facebook</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={shareToTelegram} className="cursor-pointer">
          <TelegramIcon />
          <span className="ml-2">Telegram</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={shareToWhatsApp} className="cursor-pointer">
          <WhatsAppIcon />
          <span className="ml-2">WhatsApp</span>
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        {/* 复制链接 */}
        <DropdownMenuItem onClick={copyLink} className="cursor-pointer">
          {copied ? <Check className="w-4 h-4 text-green-500" /> : <Copy className="w-4 h-4" />}
          <span className="ml-2">{copied ? t('share.copied', '已复制') : t('share.copyLink', '复制链接')}</span>
        </DropdownMenuItem>
        
        {/* 原生分享 (仅移动端显示) */}
        {typeof navigator !== 'undefined' && navigator.share && (
          <DropdownMenuItem onClick={nativeShare} className="cursor-pointer">
            <Share2 className="w-4 h-4" />
            <span className="ml-2">{t('share.more', '更多')}</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ShareButton;
